<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>Usuários/Profissionais</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Usuários/Profissionais</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO NOME DO DEPENDENTE -->
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="up.id"
                      label="Código"
                      v-bind:disabled='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-select
                      :items="usuario"
                      filled
                      v-model="up.fk_usuario"
                      item-text="nome"
                      item-value="id"
                      label="Usuário"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-select
                      :items="profissional"
                      filled
                      v-model="up.fk_profissional"
                      item-text="nome"
                      item-value="id"
                      label="Profissional"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
        </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/usuariosprofissionais')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onSaveClick()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError } from '@/utils'
import usuariosprofissionaisService from '@/services/usuariosprofissionais'
import usuarioService from '@/services/usuario'
import profissionalService from '@/services/profissional'

export default {
  name: 'viagens',
  data () {
    return {
      up: {},
      profissional: [],
      usuario: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      resultado: {}
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.up = {}
      this.profissional = []
      this.usuario = []
      const result = await profissionalService.getAllWithoutPagination()
      if (result.data === undefined) {
        this.loading = false
        showError('Não localizei profissionais!!!')
        return
      }
      this.profissional = result.data
      const result1 = await usuarioService.getAll()
      if (result1.data === undefined) {
        this.loading = false
        showError('Não localizei usuários!!!')
        return
      }
      this.usuario = result1.data
      this.loading = false
      if (id === undefined) {
        this.modo = 'I'
        return
      }
      this.modo = 'A'
      this.up = await usuariosprofissionaisService.getById(id)
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    async onSaveClick () {
      try {
        if (this.up.fk_profissional === undefined) {
          showError('Profissional não localizado!!!')
          return
        }
        if (this.up.fk_usuario === undefined) {
          showError('Veículo não localizado!!!')
          return
        }
        await usuariosprofissionaisService.savePost(this.up)
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      }
    }
  }
}
</script>
<style>
.flex{
    height: 60px;
  }
</style>
